import React, { useEffect, useState } from "react"
import { useLanguageContext } from "../context/LanguageContext"
import { Menu } from "grommet"

const LOCALE_NAMES: Record<string, string> = {
  "ko": "한국어",
  "ko-KR": "한국어",
  "en": "English",
  "en-US": "English",
  "id": "Bahasa Indonesia",
  "ja-JP": "日本語",
  "sv": "Svenska",
  "zh": "中文",
  "zh-CN": "中文",
  "zh-TW": "中文(繁體)",
  "vi": "Tiếng Việt",
  "es-ES": "Español",
  "fr-FR": "Français",
  "de-DE": "Deutsch",
  "pt-BR": "Português",
}

function localeName(locale: string): string {
  return LOCALE_NAMES[locale] || locale
}

export const LanguageSelector = () => {
  const { getLocales, changeLanguage, lang } = useLanguageContext()
  const [items, setItems] = useState([])

  useEffect(() => {
    getLocales().then((locs) =>
      setItems(
        locs.map((locale) => ({
          label: localeName(locale),
          onClick: () => changeLanguage(locale),
        }))
      )
    )
  }, [lang])

  return (
    <Menu
      size="small"
      dropProps={{
        align: { top: "bottom", left: "left" },
        elevation: "xlarge",
      }}
      label={"Language: " + localeName(lang)}
      items={items}
    />
  )
}
